<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M13.754 17.179H10.86a.843.843 0 0 1-.768-.5l-.483-1.126c-.45-1.043-1.11-2.044-2.01-3.053-1.344-1.51-1.877-3.529-1.46-5.539.5-2.385 2.435-4.32 4.82-4.82a6.333 6.333 0 0 1 5.322 1.267 6.27 6.27 0 0 1 2.336 4.896c0 1.51-.542 2.97-1.527 4.104-.992 1.16-1.66 2.152-2.085 3.145l-.484 1.117a.83.83 0 0 1-.767.5v.009ZM11.41 15.51h1.802l.267-.617c.5-1.152 1.243-2.286 2.352-3.57a4.614 4.614 0 0 0 1.117-3.02 4.62 4.62 0 0 0-1.718-3.603 4.693 4.693 0 0 0-3.928-.934 4.629 4.629 0 0 0-3.528 3.528c-.31 1.485.075 2.978 1.067 4.087 1.026 1.143 1.777 2.294 2.302 3.503l.267.617v.009ZM13.27 22h-1.926a.836.836 0 0 1-.835-.834c0-.459.376-.834.835-.834h1.926c.459 0 .834.375.834.834a.836.836 0 0 1-.834.834ZM13.754 19.59H10.86a.837.837 0 0 1-.835-.835c0-.458.376-.834.835-.834h2.894c.459 0 .834.376.834.834a.837.837 0 0 1-.834.835Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
